export type InspectionValueTypeCode = "G" | "N" | "T" | "D" | "L";

export const INSPECTION_VALUE_TYPES: {
	code: InspectionValueTypeCode;
	label: string;
}[] = [
	{ code: "G", label: "Go / No Go" },
	{ code: "N", label: "Numeric" },
	{ code: "T", label: "Text" },
	{ code: "D", label: "Date / Time" },
	{ code: "L", label: "Length (ft / in)" },
];

export interface SurfaceDefect {
	SurfaceDefectId: number | null;
	SurfaceDefectName: string;
	Color: string | null;
	IsActive: boolean;
	UsageCount: number;
}

export const SURFACE_DEFECT_INITIAL_VALUES: SurfaceDefect = {
	SurfaceDefectId: null,
	SurfaceDefectName: "",
	Color: "#3280ba",
	IsActive: true,
	UsageCount: 0,
};

export interface InspectionTemplateColumn {
	ColumnId: number | null;
	TemplateId: number | null;
	GroupName: string | null;
	ColumnLabel: string;
	ValueTypeCode: InspectionValueTypeCode;
	SortOrder: number;
	IsActive: boolean;
}

export interface InspectionTemplate {
	TemplateId: number | null;
	SectionId: number | null;
	SectionName: string;
	Rev: number;
	EffectiveFrom: Date | null;
	UploadFileId: number | null;
	DrawingFileName: string | null;
	DrawingPath: string | null;
	IsActive: boolean;
	IsCurrentRev: boolean;
	IsLatest: boolean;
	ColumnCount: number;
	InspectionCount: number;
}

export interface InspectionTemplateSection {
	SectionId: number;
	SectionName: string;
	TemplateId: number | null;
	Rev: number | null;
	EffectiveFrom: Date | null;
	ColumnCount: number;
	InspectionCount: number;
	RevisionCount: number;
}

export interface InspectionTemplatesData {
	templates: InspectionTemplate[];
	columns: InspectionTemplateColumn[];
	sections: InspectionTemplateSection[];
}

export interface InspectionTemplateDraft {
	TemplateId: number | null;
	SectionId: number | null;
	Rev: number | null;
	EffectiveFrom: Date | null;
	UploadFileId: number | null;
	Columns: InspectionTemplateColumn[];
}

export const TEMPLATE_INITIAL_VALUES: InspectionTemplateDraft = {
	TemplateId: null,
	SectionId: null,
	Rev: null,
	EffectiveFrom: null,
	UploadFileId: null,
	Columns: [],
};

export const buildUploadUrl = (path: string | null) =>
	path ? `/uploads/${encodeURI(path.replace(/\\/g, "/"))}` : null;
